import { connect, selectors } from '../../../stores'

import CampaignCard from './CampaignCard'

const mapStateToProps = (state) => ({
  ...selectors.app.selectCurrentRetailerAccountAndBrandSlug(state),
  ...selectors.content.selectCampaignStatsByCampaignId(state),
})

export default connect(mapStateToProps)(CampaignCard)
